export default {
  'deregisterFees(address[])': 'De-register fees `$1`',
  'registerFees(address[])': 'Register fees `$1`',
  'deregisterPolicies(address[])': 'De-register policies `$1`',
  'registerPolicies(address[])': 'Register policies `$1`',
  'deregisterAdapters(address[])': 'De-register adapters `$1`',
  'registerAdapters(address[])': 'Register adapters `$1`',
  'addAllowedMakers(address[])': 'Add allowed makers `$1`',
  'removeAllowedMakers(address[])': 'Remove allowed makers `$1`',
  'setSharesTokenSymbol(string)': 'Set shares token symbol `$1`',
  'removeNominatedOwner()': 'Remove nominated owner',
  'setCurrentFundDeployer(address)': 'Set current fund deployer `$1`',
  'setNominatedOwner(address)': 'Set nominated owner `$1`',
  'setMigrationTimelock(uint256)': 'Set migration time lock `$1`',
  'setComptrollerLib(address)': 'Set comptroller lib `$1`',
  'deregisterVaultCalls(address[],bytes4[])': 'De-register vault calls _contracts `$1` _selectors `$2`',
  'registerVaultCalls(address[],bytes4[])': 'Register vault calls _contracts `$1` _selectors `$2`',
  'addDerivatives(address[],address[])': 'Add derivatives _derivatives `$1` _priceFeeds `$2`',
  'removeDerivatives(address[])': 'Remove derivatives `$1`',
  'updateDerivatives(address[],address[])': 'Update derivatives _derivatives `$1` _priceFeeds `$2`',
  'setEthUsdAggregator(address)': 'Set ETH-USD aggregator `$1`',
  'addPrimitives(address[],address[],uint256[])': 'Add primitives _primatives `$1` _aggregators `$2` _rateAssets `$3`',
  'removePrimitives(address[])': 'Remove primitives `$1`',
  'updatePrimitives(address[],address[])': 'Update primitives _primatives `$1` _aggregators `$2`',
  'setStaleRateThreshold(uint256)': 'Set staleRateThreshold `$1`',
  'addPoolTokens(address[])': 'Add pool tokens `$1`',
  'addCTokens(address[])': 'Add cTokens `$1`',
  'addSynths(address[])': 'Add Synths `$1`',
  'setRedemptionWindowBuffer(uint256)': 'Set redemptionWindowBuffer `$1`',
  'addRedemptionBlockingAdapters(address[])': 'Add redemption blocking adapters `$1`',
  'removeRedemptionBlockingAdapters(address[])': 'Remove redemption blocking adapters `$1`'
}
